import React from "react"
import "./btn-generic.scss"
export default function BtnGeneric({ title, isActive, onClick = () => {} }) {
  return (
    <button
      className={`btn-generic ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      <p className="btn-title">{title}</p>
    </button>
  )
}
